module.exports = __webpack_public_path__ + "static-appopensalud/img/menttum.2ba4be7.svg";


//////////////////
// WEBPACK FOOTER
// ./static-appopensalud/img/logos/menttum.svg
// module id = 1023
// module chunks = 117